import React, { useState } from "react";
import "../styles/Slider.css";
import "../styles/swiper.min.css";
import { FaArrowRight, FaArrowLeft } from "react-icons/fa";
import sliderone from "../../../images/slider-one.png";
import slidertwo from "../../../images/slider-two.png";
import sliderthree from "../../../images/slider-three.png";
import { Link } from "react-router-dom";

const Slider = () => {
  const [sliders] = useState([
    {
      id: 1,
      title: "Provides quality insurance",
      image: slidertwo,
    },
    {
      id: 2,
      title: "Provides quality insurance",
      image: sliderone,
    },
    {
      id: 3,
      title: "Provides quality insurance",
      image: sliderthree,
    },
  ]);
  return (
    <div>
      <section className="main-slider main-slider-two">
        <div
          className="swiper-container thm-swiper__slider"
          data-swiper-options='{"slidesPerView": 1, "loop": true,
    "effect": "fade",
     "pagination": {
        "el": "#main-slider-pagination",
        "type": "bullets",
        "clickable": true
      },
    "navigation": {
        "nextEl": "#main-slider__swiper-button-next",
        "prevEl": "#main-slider__swiper-button-prev"
    },
    "autoplay": {
        "delay": 5000
    }}'
        >
          <div className="swiper-wrapper">
            {sliders.map((slider) => (
              <div className="swiper-slide">
                <div
                  className="image-layer"
                  style={{ backgroundImage: `url(${slider.image})` }}
                ></div>

                <div className="container">
                  <div className="row">
                    <div className="col-xl-12">
                      <div className="main-slider__content">
                        <h2>{slider.title}</h2>
                        <Link to="" className="thm-btn">
                          Discover More
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="swiper-pagination" id="main-slider-pagination"></div>
          <div className="main-slider__nav-two">
            <div
              className="swiper-button-prev"
              id="main-slider__swiper-button-next"
            >
              <FaArrowLeft />
            </div>
            <div
              className="swiper-button-next"
              id="main-slider__swiper-button-prev"
            >
              <FaArrowRight />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Slider;
